import { Helmet } from "react-helmet";

// TODO: uncomment and add schema markup if needed seo team

// const schemaMarkupObj = {
//   "@context": "https://schema.org",
//   "@type": "WebSite",
//   name: "Homes Globe",
//   url: "https://homesglobe.com"
// };

const SeoHelmet = ({
  title,
  description,
  keywords,
  canonical = "https://homesglobe.com"
  // schemaMarkup = schemaMarkupObj
}) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta name="keywords" content={keywords} />
    <link rel="canonical" href={canonical} />

    {/* TODO: uncomment and add schema markup if needed seo team */}
    {/* Structured Data (Schema Markup) */}
    {/* {schemaMarkup && (
      <script type="application/ld+json">{JSON.stringify(schemaMarkup)}</script>
    )} */}
  </Helmet>
);

export default SeoHelmet;
